import { fetchJSON } from "../util/fetch-utils";
import VelavuAPIMappedin from "./integrations/velavu-api-mappedin";
export default class VelavuAPIIntegrations {
    mappedin = new VelavuAPIMappedin();
    /**
     * This method returns all integrations.
     */
    getIntegrations() {
        return fetchJSON("/integrations");
    }
    ;
}
//# sourceMappingURL=velavu-api-integrations.js.map